export default class OfferCampaignCreate {
  constructor($scope, OfferCampaignService) {
    $scope.create = function() {
      $scope.creating = true;
      OfferCampaignService.create($scope.campaign).success(function(data) {
        if (data.success)
          window.location = '/admin/marketplace/campaigns/offers/' + data.offer_campaign_id;
      });
    };

    $scope.init = function() {
      $scope.campaign = {
        offer_id: window.offer_id,
        title: window.offer_title,
        max_embedded_matched_rows: 12
      };
    };

    $scope.init();
  }
}

OfferCampaignCreate.$inject = ['$scope', 'OfferCampaignService'];



// WEBPACK FOOTER //
// ./front/js/admin/controllers/offer-campaign-create.ctrl.js